import { render, staticRenderFns } from "./DashboardProjectsGrid.vue?vue&type=template&id=0b5faf05"
import script from "./DashboardProjectsGrid.vue?vue&type=script&lang=js"
export * from "./DashboardProjectsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports